// Generated by AvenyModelEditor 2018-08-13 09:22

import { IProcessModel } from '../../Types/ProcessModel';

export const ProcessModel: IProcessModel = {
  Processer: [
    {
      Kod: '3',
      Benamning: 'Hantera ekonomi',
      Input: 'Leverantörsfaktura ankommer mm...',
      Output: 'Löpande händelser bokförda och avstämda mm...',
      Dokumentation: 'Här finns det systemstöd i Aveny',
      Delprocesser: [
        {
          Kod: '3.1',
          Benamning: 'Hantera löpande redovisning',
          Aktivitetsfloden: [
            {
              Kod: '3.1.1',
              Benamning: 'Hantera elektroniskt fakturaflöde',
              Input: 'Faktura ankommer',
              Output: 'Faktura betald',
              Aktiviteter: [
                {
                  ID: 'paktSkannaTolkaFaktura',
                  Rubrik: 'Faktura ankommer',
                  Aveny: false,
                },
                {
                  ID: 'paktSkannaTolkaFaktura',
                  Rubrik: 'Skanna, tolka och arkivera',
                  Underrubrik:
                    'Fakturan skannas och utvalda fält tolkas av skanningsleverantör.',
                  Beskrivning:
                    'Fakturan skannas och utvalda fält tolkas av skanningsleverantör. Pappersfaktura samt skannad bild arkiveras hos skanningsleverantören.',
                  NegativtResultat: 'Om faktura saknas kontakta kanslistöd.',
                  PositivtResultat: 'Fakturan skannad.',
                  Aveny: false,
                },
                {
                  ID: 'paktLasaInFakturabuntAnkomstregistrera',
                  Rubrik: 'Läs in fakturabunt',
                  Underrubrik: 'Utförs automatiskt',
                  Beskrivning: 'Fakturabunt läses in',
                  NegativtResultat:
                    'Aveny varnar om inläsning misslyckats. Kontakta kanslistöd.',
                  PositivtResultat: 'Fakturabunt inläst.',
                  Aveny: true,
                  Automatisk: true,
                  H: [7121],
                },
                {
                  ID: 'paktLasaInFakturabuntAnkomstregistrera',
                  Rubrik: 'Ankomstregistrera',
                  Underrubrik:
                    'Registrera leverantörsfakturan och förbereda för attest',
                  Beskrivning:
                    'Alla fält fylls i utifrån den tolkade informationen. För leverantörsfakturor där all information är korrekt behöver användaren endast godkänna. Om det saknas information måste användaren komplettera fälten manuellt.',
                  NegativtResultat:
                    'Om en faktura ej ska ankomstregistreras t.ex. pga dubblett eller fel mottagare ska fakturan tas bort ur bunten.',
                  PositivtResultat:
                    'Fakturan ankomstregistrerad. Verifikationen sparad och mail skickas till mottagningsattestant.',
                  Aveny: true,
                  Automatisk: false,
                  H: [7121],
                },
                {
                  ID: 'paktSakgranskaMottagningsattesteraFaktura',
                  Rubrik: 'Mottagningsattest',
                  Underrubrik:
                    'Sakgranska, kontera och mottagningsattestera fakturan',
                  Beskrivning:
                    'Stäm av all information på fakturan. Ange vilken typ av kostnad det är, vilken verksamhet som är ansvarig m.m. med hjälp av koder från kodplanen. Möjligt att bifoga dokument, skriva kommentarer eller ändra attestanter. Om allt är korrekt godkänns fakturan.',
                  NegativtResultat:
                    'Fakturan skickas till utredning med kommentar om vad som behöver åtgärdas.',
                  PositivtResultat:
                    'Fakturan mottagningsattesterad, mail skickas till nästa attestant.',
                  Aveny: true,
                  Automatisk: false,
                  H: [7124, 7123, 7127, 7126],
                  U: [7125],
                  K: [7121],
                },
                // {
                //   ID: 'paktKonteraFaktura',
                //   Rubrik: 'Kontera faktura',
                //   Beskrivning: '',
                //   NegativtResultat: '',
                //   PositivtResultat: '',
                //   Aveny: true,
                //   H: [7123],
                //   U: [7125],
                //   K: [7120, 7121],
                // },
                {
                  ID: 'paktBeslutsattesteraFaktura',
                  Rubrik: 'Beslutsattest',
                  Underrubrik:
                    'Granska fakturan, kontrollera och komplettera kontering samt beslutsattestera fakturan',
                  Beskrivning:
                    'Stäm av all information på fakturan. Kontrollera att koderna som angivits är korrekta. Komplettera vid behov så att det är rätt typ av kostnad, rätt verksamhet som är ansvarig m.m. med hjälp av koder från kodplanen. Möjligt att bifoga dokument, skriva kommentarer eller ändra attestanter. Om allt är korrekt godkänns fakturan.',
                  NegativtResultat:
                    'Fakturan skickas till utredning med kommentar om vad som behöver åtgärdas.',
                  PositivtResultat:
                    'Fakturan beslutsattesterad, mail skickas till nästa attestant eller vidare för definitivbokning.',
                  Aveny: true,
                  Automatisk: false,
                  H: [7124, 7123, 7127],
                  U: [7124, 7123, 7127, 7126],
                  K: [7121],
                },
                {
                  ID: 'paktKontrollattesteraFaktura',
                  Rubrik: 'Kontrollattest',
                  Underrubrik:
                    'Extra attest för viss attestkedja eller för visst attestbelopp. Granska fakturan, kontrollera och komplettera kontering samt kontrollattestera fakturan',
                  Beskrivning:
                    'Stäm av all information på fakturan. Kontrollera att koderna som angivits är korrekta. Komplettera vid behov så att det är rätt typ av kostnad, rätt verksamhet som är ansvarig m.m. med hjälp av koder från kodplanen. Möjligt att bifoga dokument, skriva kommentarer eller ändra attestanter. Om allt är korrekt godkänns fakturan.',
                  NegativtResultat:
                    'Fakturan skickas till utredning med kommentar om vad som behöver åtgärdas.',
                  PositivtResultat:
                    'Fakturan kontrollattesterad, mail skickas till nästa attestant eller vidare för definitivbokning.',
                  Aveny: true,
                  H: [7124, 7123, 7127],
                  U: [7124, 7123, 7127],
                  K: [7121],
                },
                {
                  ID: 'Definitivbokning',
                  Rubrik: 'Definitivbokning',
                  Underrubrik:
                    'Då fakturan är attesterad bokförs kostnaderna och fakturan är klar att betalas',
                  Beskrivning:
                    'Alla fält fylls i utifrån den attesterade informationen. För leverantörsfakturor där all information är korrekt behöver användaren endast godkänna. Om det saknas information måste användaren komplettera fälten manuellt.',
                  NegativtResultat:
                    'Om en faktura ej ska ingå i bokföringen kan ankomstregistreringens händelse makuleras.',
                  PositivtResultat:
                    'Fakturan defintivbokförd. Kostnaden registrerad och fakturan kan betalas.',
                  Aveny: true,
                  H: [7121],
                },
                {
                  ID: 'SkapaUtbetalningsorder',
                  Rubrik: 'Skapa utbetalningsorder',
                  Underrubrik:
                    'För varje utbetalningsväg skapas en utbetalningsorder utifrån förfallodatum',
                  Beskrivning:
                    'En fil skapas med de fakturor som är klara för betalning och som förfaller innan en viss tidpunkt, alternativt skickas alla fakturor som är definitivbokade och därmed klara för betalning med. Möjligt att då filen skapas exkludera utvalda fakturor. Fakturor som sedan tidigare är spärrade för betalning inkluderas ej. Filen skapas och sparas ner på en bestämd plats med ett filnamn som beskriver filinnehåll och datum.',
                  NegativtResultat:
                    'Filen skapas ej korrekt, kontakta supporten.',
                  PositivtResultat: 'Utbetalningsorderfilen skapad.',
                  Aveny: true,
                  H: [7121],
                },
                {
                  ID: 'Betalning',
                  Rubrik: 'Betalning',
                  Underrubrik: 'Utförs på internetbanken',
                  Beskrivning:
                    'Filen med utbetalningsordern hämtas och läses in i internetbanken. Bevakning av de ingående fakturornas förfallodatum och betalning till leverantörens konto.',
                  NegativtResultat:
                    'Fakturan ej betald, t.ex. vid fel kontonummer.',
                  PositivtResultat: 'Fakturan betald hos leverantören.',
                  Aveny: false,
                  H: [7121],
                },
                {
                  ID: 'Aterredovisning',
                  Rubrik: 'Återredovisning',
                  Underrubrik:
                    'Fil med utförda betalningar läses tillbaka in i Aveny',
                  Beskrivning:
                    'Fil med utförda betalningar läses tillbaka in i Aveny och systemet prickar av de betalningar som går att matcha mot ett fakturanummer som betalda. De betalningar som ej går att matcha mot ett fakturanummer listas och hanteras manuellt. Andra noterade avvikelser i filen från banken hanteras även de manuellt, t.ex. misslyckade betalningar.',
                  NegativtResultat:
                    'Filen läses ej korrekt, kontakta supporten.',
                  PositivtResultat:
                    'Fakturan har status betald och förändringen av leverantörsskulden och banksaldot är bokförd.',
                  Aveny: true,
                },
                {
                  ID: 'paktSkannaTolkaFaktura',
                  Rubrik: 'Faktura betald',
                  Aveny: false,
                },
              ],
            },
            {
              Kod: '3.1.2',
              Benamning: 'Hantera leverantörsreskontra',
              Input:
                'Attesterad leverantörsfaktura, uppgift om ny leverantör eller förändrade leverantörsuppgifter',
              Output:
                'Leverantörsfaktura betald och bokförd. Avstämningsrapport.',
              Aktiviteter: [
                {
                  ID: 'paktUppratthallaLeverantorsregister',
                  Rubrik: 'Upprätthålla leverantörsregister',
                  Beskrivning: '',
                  NegativtResultat: '',
                  PositivtResultat: '',
                  Aveny: true,
                  H: [7120],
                  U: [7121],
                },
                {
                  ID: 'paktBokforaLeverantorsskulder',
                  Rubrik: 'Bokföra leverantörsskulder',
                  Beskrivning: '',
                  NegativtResultat: '',
                  PositivtResultat: '',
                  Aveny: true,
                  H: [7120],
                  U: [7121],
                },
                {
                  ID: 'paktBevakaBetalningsdatum',
                  Rubrik: 'Bevaka betalningsdatum',
                  Underrubrik: 'Görs automatiskt i Aveny',
                  Beskrivning: '',
                  NegativtResultat: '',
                  PositivtResultat: '',
                  Aveny: true,
                  H: [7120],
                  U: [7121],
                  K: [7125],
                },
                {
                  ID: 'paktBetalaFaktura',
                  Rubrik: 'Betala faktura',
                  Beskrivning: '',
                  NegativtResultat: '',
                  PositivtResultat: '',
                  Aveny: true,
                  H: [7120],
                  U: [7121],
                },
                {
                  ID: 'paktBokforaBetalningsuppdrag',
                  Rubrik: 'Bokföra betalningsuppdrag',
                  Beskrivning: '',
                  NegativtResultat: '',
                  PositivtResultat: '',
                  Aveny: true,
                  H: [7120],
                  U: [7121],
                },
                {
                  ID: 'paktStammaAvReskontra',
                  Rubrik: 'Stämma av reskontra',
                  Beskrivning: '',
                  NegativtResultat: '',
                  PositivtResultat: '',
                  Aveny: true,
                  H: [7120],
                  U: [7121],
                },
              ],
            },
          ],
        },
        {
          Kod: '3.2',
          Benamning: 'Hantera moms och skatter',
          Aktivitetsfloden: [
            {
              Kod: '3.2',
              Benamning: 'Hantera moms och skatter',
              Input:
                'Bokförd leverantörsfaktura, kundfordring, avskrivning, löpande verksamhetshändelse',
              Output:
                'Deklarerad skatt, inkomst, moms. Betald skatt och moms. Avstämt skattekonto.',
              Aktiviteter: [
                {
                  ID: 'paktUpprattaArbetsgivardeklaration',
                  Rubrik: 'Upprätta arbetsgivardeklaration',
                  Beskrivning: '',
                  NegativtResultat: '',
                  PositivtResultat: '',
                  Aveny: true,
                  H: [7120],
                  U: [7130],
                  K: [7123],
                  Periodicitet: 'Månad',
                },
                {
                  ID: 'paktUpprattaInkomstdeklaration',
                  Rubrik: 'Upprätta inkomstdeklaration',
                  Beskrivning: '',
                  NegativtResultat: '',
                  PositivtResultat: '',
                  Aveny: true,
                  H: [7124, 7123, 7131],
                  U: [7124, 7123, 7131],
                  Periodicitet: 'År',
                },
                {
                  ID: 'paktHanteraMomspliktigVerksamhet',
                  Rubrik:
                    'Hantera momspliktig verksamhet och upprätta momsdeklaration',
                  Beskrivning: '',
                  NegativtResultat: '',
                  PositivtResultat: '',
                  Aveny: true,
                  H: [7123],
                  U: [7120],
                  K: [7124, 7123],
                  Periodicitet: 'Månad',
                },
                {
                  ID: 'paktHanteraFrivilligFastighetsmoms',
                  Rubrik:
                    'Hantera frivillig skattskyldighet för fastighetsmoms',
                  Beskrivning: '',
                  NegativtResultat: '',
                  PositivtResultat: '',
                  Aveny: true,
                  H: [7123],
                  U: [7120],
                  K: [7124, 7123, 7126],
                },
                {
                  ID: 'paktHanteraSkattekonto',
                  Rubrik: 'Hantera skattekonto',
                  Beskrivning: '',
                  NegativtResultat: '',
                  PositivtResultat: '',
                  Aveny: true,
                  H: [7120],
                  U: [7120],
                  Periodicitet: 'År',
                },
              ],
            },
          ],
        },
        {
          Kod: '3.3',
          Benamning: 'Hantera finansiella tillgångar',
          Aktivitetsfloden: [
            {
              Kod: '3.3',
              Benamning: 'Hantera finansiella tillgångar',
              Input:
                'Beslut om kort- och långfristiga placeringar samt stiftelse-medel. Aktuell huvudbok. Utdrag från bankkonto.',
              Output:
                'Analyserad likviditet. Hanterade placeringar och stiftelse-medel.',
              Aktiviteter: [
                {
                  ID: 'paktBevakaLikvidaMedel',
                  Rubrik: 'Bevaka att likvida medel finns på aktuella konton',
                  Beskrivning: '',
                  NegativtResultat: '',
                  PositivtResultat: '',
                  Aveny: true,
                  H: [7120],
                  U: [7120],
                  K: [7123, 7126],
                },
                {
                  ID: 'paktAnalyseraLikviditetsrapport',
                  Rubrik: 'Ta fram och analysera likviditetsrapport',
                  Beskrivning: '',
                  NegativtResultat: '',
                  PositivtResultat: '',
                  Aveny: true,
                  H: [7131],
                  U: [7131],
                  K: [7123],
                  I: [7123],
                  Periodicitet: 'Månad',
                },
                {
                  ID: 'paktHanteraKortfristigaPlaceringar',
                  Rubrik: 'Hantera kortfristiga placeringar',
                  Beskrivning: '',
                  NegativtResultat: '',
                  PositivtResultat: '',
                  Aveny: true,
                  H: [7124],
                  U: [7123],
                  I: [7131],
                },
                {
                  ID: 'paktHanteraLangfristigaPlaceringar',
                  Rubrik: 'Hantera långfristiga placeringar',
                  Beskrivning: '',
                  NegativtResultat: '',
                  PositivtResultat: '',
                  Aveny: true,
                  H: [7124],
                  U: [7123],
                  I: [7131],
                },
                {
                  ID: 'paktHanteraStiftelsemedel',
                  Rubrik: 'Hantera stiftelsemedel',
                  Beskrivning: '',
                  NegativtResultat: '',
                  PositivtResultat: '',
                  Aveny: true,
                  H: [7123],
                  U: [7123, 7120],
                  I: [7131],
                },
              ],
            },
          ],
        },
        {
          Kod: '3.4',
          Benamning: 'Upprätta bokslut',
          Aktivitetsfloden: [
            {
              Kod: '3.4',
              Benamning: 'Upprätta bokslut',
              Input:
                'Bokslutsanvisningar. Bokförda och avstämda löpande ekonomiska verksamhetshändelser. Personal- och lönestatistik. Beräknad förmånsbestämd ålderspension.',
              Output:
                'Bokslut respektive årsredovisning klar för analys/uppföljning. Levererad statistik till myndigheter och andra externa parter.',
              Aktiviteter: [
                {
                  ID: 'paktTaFramBokslutsanvisningar',
                  Rubrik: 'Ta fram bokslutsanvisningar',
                  Beskrivning: '',
                  NegativtResultat: '',
                  PositivtResultat: '',
                  Aveny: true,
                  H: [7120],
                  U: [7120],
                  K: [7123, 7131],
                  I: [7123, 7131],
                  Periodicitet: 'År',
                },
                {
                  ID: 'paktUpprattaManadsrapporterArsbokslut',
                  Rubrik: 'Upprätta månadsrapporter och årsbokslut',
                  Beskrivning: '',
                  NegativtResultat: '',
                  PositivtResultat: '',
                  Aveny: true,
                  H: [7120],
                  U: [7120],
                  K: [7131],
                  I: [7123, 7131],
                  Periodicitet: 'Månad/År',
                },
                {
                  ID: 'paktUpprattaStiftelsebokslut',
                  Rubrik: 'Upprätta stiftelsebokslut',
                  Beskrivning: '',
                  NegativtResultat: '',
                  PositivtResultat: '',
                  Aveny: true,
                  H: [7120],
                  U: [7120],
                  K: [7131],
                  I: [7131],
                  Periodicitet: 'Månad/År',
                },
                {
                  ID: 'paktTextunderlagForvaltningsberattelsen',
                  Rubrik:
                    'Skapa verksamhetens textunderlag till förvaltningsberättelsen',
                  Beskrivning: '',
                  NegativtResultat: '',
                  PositivtResultat: '',
                  Aveny: true,
                  H: [7123, 7127],
                  U: [7123, 7127, 7131],
                  K: [7124, 7126],
                  I: [7124, 7126],
                  Periodicitet: 'År',
                },
                {
                  ID: 'paktUpprattaArsredovisning',
                  Rubrik:
                    'Upprätta årsredovisning och noter (församling/stiftelse)',
                  Beskrivning: '',
                  NegativtResultat: '',
                  PositivtResultat: '',
                  Aveny: true,
                  H: [7123, 7127],
                  U: [7131],
                  K: [7123, 7127],
                  I: [7123, 7127],
                  Periodicitet: 'År',
                },
                {
                  ID: 'paktUpprattaRapporteraStatistikSCB',
                  Rubrik: 'Upprätta och rapportera statistik till SCB',
                  Beskrivning: '',
                  NegativtResultat: '',
                  PositivtResultat: '',
                  Aveny: true,
                  H: [7131],
                  U: [7131],
                  K: [7120],
                  Periodicitet: 'År',
                },
              ],
            },
          ],
        },
      ],
    },
  ],
};
